import React from "react";
import Reveal from "./Reveal";

export default function About() {
  return (
    <section id="about" className="section-alt">
      <div className="wrap">
        <Reveal className="section-head">
          <div className="eyebrow">About Us</div>
          <h2>Built by researchers, for researchers</h2>
          <p>
            Infinity Research Work exists to close the gap between strong
            research and the paperwork that stands between a scholar and
            their degree.
          </p>
        </Reveal>

        <div className="about-grid">
          <Reveal as="div">
            <p>
              What began as a small circle of PhD mentors helping friends
              polish their theses has grown into a nationwide support
              network for scholars across every discipline — engineering,
              medicine, law, commerce, and beyond.
            </p>
            <p style={{ marginBottom: 0 }}>
              We don't hand your work to generic freelancers. Every project
              is matched with a subject-matter specialist who holds a
              Master's or PhD in your exact field, so the guidance you get
              understands your research — not just your formatting.
            </p>
          </Reveal>

          <Reveal as="div" className="about-card">
            <h3 style={{ fontSize: "1.1rem" }}>Why scholars trust us</h3>
            <ul className="contact-list about-values">
              <li>🎓 <span><b>500+ subject-matter experts</b> across every major discipline</span></li>
              <li>🔒 <span><b>100% confidential</b> handling of your research and personal data</span></li>
              <li>📈 <span><b>95% submission success rate</b> across our scholar network</span></li>
              <li>🤝 <span><b>A personal roadmap</b> for every scholar — never a template</span></li>
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
